<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">
          SmartAgro
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            ¡Bienvenid@ a SmartAgro!
          </b-card-title>
          <b-card-text class="mb-2">
            Ingrese sus datos
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="Usuario"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Usuario"
                  vid="email"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="user"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label>Contraseña</label>
                  <b-link href='mailto:renzo.carranza@agrovisioncorp.com?cc=antony.sanchez@agrovisioncorp.com&subject=Solicitud de restablecimiento de usuario y contraseña en la plataforma "SmartAgro"'>
                    <small>¿Te olvidaste la contraseña?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Contraseña"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>
              -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="loading"
              >
                <span v-if="loading">Accediendo...   &emsp13;<feather-icon icon="RefreshCwIcon" size="16" class="spinner"/></span>
                <span v-else>Ingresar   &emsp13;<feather-icon icon="LogInIcon" size="16"/></span>
              </b-button>
            </b-form>
          </validation-observer>

          <!--
          <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{name:'auth-register'}">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text>
          -->

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
              <dark-Toggler class="d-none d-lg-block" />
            </div>
          </div>
          <span class="d-md-block text-center font-small-2 font-weight-bold text-secondary">Aplicaciones de Software &emsp14;
            <font-awesome-icon icon="fa-solid fa-code" class="text-danger stroke-current" />
          </span>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'

import axiosIns from '../../../libs/axios'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    VuexyLogo,
    DarkToggler,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: null,
      user: null,
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      loading: false,

      // validation rules
      required,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2.svg')
      }

      return this.sideImg
    },
  },
  mounted() {
    localize("es");
  },
  methods: {
    login2() {
      const yo = this
      this.$refs.loginForm.validate().then(success => {
        if (success) {

          useJwt.login({
            email: yo.user,
            password: yo.password,
          })
            .then(response => {
              const { userData } = response.data
              console.log(userData)
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))
              yo.$ability.update(userData.ability)

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              yo.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              yo.$router.replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  yo.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Bienvenido\n ${userData.fullName || userData.username}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: `Has iniciado sesión correctamente como ${userData.role}. ¡Ya puedes empezar a explorar!`,
                    },
                  })
                })
            })
            .catch(error => {
              yo.$refs.loginForm.setErrors(error.response.data.error)
            })
        }
      })
    },
    login() {
      const yo = this
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          yo.loading = true
          const data = JSON.stringify({
            'username': this.user,
            'password': this.password
          });

          const config = {
            method: 'post',
            url: '/configuracion/api-token-v3/',
            data: data,
            headers: {
              'Content-Type': 'application/json'
            },
          };

          axiosIns(config)
              .then(function (response) {
                if(response.status===200){
                  // const key = response.data.access.split('.')
                  const datos = response.data.user_info
                  const csrfToken = response.data.csrfToken;

                  let menu = ''
                  const habilidades = []
                  let permisos = []
                  let pos = 0

                  for (let value of datos.permisos){
                    if (pos!==0){
                      if(value.smenu !== menu){
                        habilidades.push({action: permisos, subject:menu})
                        permisos = []
                      }
                    }

                    permisos.push(value.spermiso)

                    menu = value.smenu
                    pos++

                    if (pos===datos.permisos.length){
                      habilidades.push({action: permisos, subject:menu})
                    }
                  }

                  habilidades.push({action: 'read', subject: 'Auth'}, {action: 'read', subject: 'Inicio'})

                  const userData = {
                    "id":datos.id,
                    "fullName":datos.name,
                    "username":datos.username,
                    "avatar":"/img/13-small.d796bffd.png",
                    "email":datos.email,
                    "role":datos.rol,
                    "dni":datos.dni,
                    "ability":habilidades,
                    "extras":{
                      "eCommerceCartItemsCount":5
                    }
                  }
                  // useJwt.setToken(response.data.access)
                  // useJwt.setRefreshToken(response.data.refresh)
                  localStorage.setItem('userData', JSON.stringify(userData))
                  localStorage.setItem('csrfToken', csrfToken);
                  yo.$ability.update(userData.ability)


                  // ? This is just for demo purpose as well.
                  // ? Because we are showing eCommerce app's cart items count in navbar
                  yo.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

                  // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
                  yo.$router.replace(getHomeRouteForLoggedInUser('inicio'))
                      .then(() => {
                        yo.$toast({
                          component: ToastificationContent,
                          position: 'top-right',
                          props: {
                            title: `Bienvenido \n ${userData.fullName || userData.username}`,
                            icon: 'CoffeeIcon',
                            variant: 'success',
                            text: `Has iniciado sesión correctamente. ¡Ya puedes empezar a explorar!`,
                          },
                        },
                            {
                              position: 'top-center',
                            })
                      })
                }
                else if(response.status===401){
                  yo.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Error`,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                      text: `Usuario o contraseña incorrecta.`,
                    },
                  },
                  {
                    position: 'top-center',
                  })
                }
                else if(response.status===400){
                  yo.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Error`,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                      text: `Usuario o contraseña incorrecta.`,
                    },
                  },
                  {
                    position: 'top-center',
                  })
                }
              })
              .catch(function (error) {
                yo.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Error`,
                      icon: 'AlertTriangleIcon',
                      variant: 'danger',
                      text: `Usuario o contraseña incorrecta.`,
                    },
                  },
                  {
                    position: 'top-center',
                  })
              })
              .finally(function (){
                yo.loading = false
              });

        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
